module.exports = __webpack_public_path__ + "static/media/cam.98428d7e.png";